import { render, staticRenderFns } from "./otelislem.vue?vue&type=template&id=8fc31da8"
import script from "./otelislem.vue?vue&type=script&lang=js"
export * from "./otelislem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports